import { render, staticRenderFns } from "./account-tasks.vue?vue&type=template&id=bbd98f66&"
import script from "./account-tasks.vue?vue&type=script&lang=js&"
export * from "./account-tasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports